import useShowDialogAlert from "components/DialogAlert/utils/hooks/useDialogAlert";
import { requestAddStudentsToGroupRoomReservation } from "services/resources/library/aboutLibraryResources";
import { ERROR_ADD_STUDENT_TO_GROUP_RESERVATION } from "../../../utils/constants";
import { ACTION_TYPES } from "../constants";

const useAddStudent = ({
    reservationId,
    students: {
        studentList,
        setStudentList,
        studentsSelectedToUse,
        setStudentsSelectedToUse
    },
    dialogs: {
        dialogShowResolveRequest
    },
    addActionTypeToListActions,
    setSuccessToDoActionOnStudent,
    setResolveType,
    loadingRequest
}) => {
    //#region Hooks
    const dialogShowAddStudentConfirmation = useShowDialogAlert();
    //#endregion
    //#region Functions
    const studentAlreadyExistsInReservationList = () => {
        return studentList.some(({ id }) => {
            return studentsSelectedToUse.some((studentSelected => id === studentSelected.id));
        });
    }
    const addStudentToReservationList = () => {
        setResolveType(ACTION_TYPES.ADD);
        // Cerrando modal de confirmación para agregar estudiante
        dialogShowAddStudentConfirmation.set(false);
        // Abriendo modal de resolución de petición
        dialogShowResolveRequest.set(true);
        // Verificando si el estudiante ya existe en la lissta
        if (studentAlreadyExistsInReservationList()) {
            setSuccessToDoActionOnStudent(false);
            // Abriendo modal de resolución de petición
            dialogShowResolveRequest.set(true);
            return;
        }
        setSuccessToDoActionOnStudent(true);
        // Agregando estudiante nuevo a la lista
        setStudentList([...studentList, {
            ...studentsSelectedToUse[0],
            saved: false
        }]);
        addActionTypeToListActions(ACTION_TYPES.ADD);
    }
    const confirmAddStudent = studentToAdd => {
        setStudentsSelectedToUse([studentToAdd]);
        dialogShowAddStudentConfirmation.set(true);
    }
    const doRequestAddStudentToReservationList = async () => {
        // Realizando petición de agregado de estudiante
        loadingRequest.show("Agregando alumno(s)...");
        const { success, message } = await requestAddStudentsToGroupRoomReservation({
            reservationId,
            students: studentList.filter(({ saved }) => !saved)
        });
        loadingRequest.hide();
        // Gestionando errores
        if (message === ERROR_ADD_STUDENT_TO_GROUP_RESERVATION.STUDENT_ADDED) {
            setSuccessToDoActionOnStudent(false);
            // Abriendo modal de resolución de petición
            dialogShowResolveRequest.set(true);
            throw new Error(false);
        }
        if (message === ERROR_ADD_STUDENT_TO_GROUP_RESERVATION.ERROR_TO_ADDING || 
            !success) {
            throw new Error(true);
        }
    }
    //#endregion
    return {
        fns: {
            addStudentToReservationList,
            confirmAddStudent,
            doRequestAddStudentToReservationList
        },
        dialogs: {
            dialogShowAddStudentConfirmation
        }
    };
}	
    
export default useAddStudent;